import React from "react";
import Buttons from "../Button/Button";
import styles from "./SearchResult.module.css";

const SearchEmptyCard = (props) => {
  return (
    <div className={styles.EmptyCard}>
      {props.icon}
      <h1>{props.title}<b>{props.keyword}</b></h1>
      <p>{props.description}</p>
      {props.showButton && (
        <Buttons
          label={props.btnLabel}
          buttonColor="#004FE0"
          color="#fff"
          width="160px"
          height="48px"
          fontSize="14px"
          link={props.btnLink}
        />
      )}
    </div>
  );
};

export default SearchEmptyCard;
